// Öffentliche API der Statusanzeige „Automatische Akkorderkennung" (geteilt vom
// Akkorderkennungs-Panel, der Notenvorschau und dem Verlauf). Der Zustand selbst wird
// inhaltsbasiert aus dem MusicXML abgeleitet – siehe `chordInferenceStatus` in
// `@/composables/musicXmlDom`.
export {default as ChordInferenceBadge} from './ChordInferenceBadge.vue'
export {CHORD_INFERENCE_DISPLAY, formatChordInferenceText} from './chordInferenceDisplay'
export type {ChordInferenceDisplay} from './chordInferenceDisplay'
